import { z } from 'zod';
import { UUIDSchema } from '../ids.js';
export const EventType = z.enum([
    // Official UniFi webhook names
    'access.door.unlock',
    'access.doorbell.incoming',
    'access.doorbell.completed',
    'access.device.dps_status',
    'access.visitor.status.changed',
    'access.data.device.remote_unlock',
    // Legacy/internal names kept for backward compatibility
    'access.authorized',
    'access.denied',
    'door.forced_open',
    'door.held_open',
    'intercom.call_start',
    'enrollment.detected',
    'device.state_changed',
    'lockdown.changed',
    'audit.appended',
    'snapshot.available',
]);
export const EventSeverity = z.enum(['info', 'warn', 'alert']);
export const PortalEvent = z.object({
    id: UUIDSchema,
    tenant_id: UUIDSchema,
    type: EventType,
    severity: EventSeverity,
    unifi_device_id: z.string().nullable(),
    unifi_user_id: z.string().nullable(),
    snapshot_id: UUIDSchema.nullable(),
    occurred_at: z.string().datetime(),
    payload: z.record(z.string(), z.unknown()),
});
export const SSEFrame = z.object({
    id: z.number().int().nonnegative(),
    type: EventType,
    data: PortalEvent,
});
// Inbound webhook payload from UniFi — the controller's event shape.
// `event` is intentionally a free string so we can store events whose type we
// haven't catalogued yet (raw_payload preserves the full record for forensics
// and Phase-1 schema work). Known types still get the normalized handling.
export const UnifiWebhookEnvelope = z.object({
    event: z.string().min(1).max(120),
    event_id: z.string().min(1).optional(),
    event_object_id: z.string().min(1).optional(),
    receiver_id: z.string().min(1).optional(),
    occurred_at: z.union([z.string().datetime(), z.number().int()]).optional(),
    data: z.record(z.string(), z.unknown()).optional(),
    severity: EventSeverity.optional(),
}).passthrough();
const KNOWN_EVENT_TYPES = new Set([
    'access.door.unlock',
    'access.doorbell.incoming',
    'access.doorbell.completed',
    'access.device.dps_status',
    'access.visitor.status.changed',
    'access.data.device.remote_unlock',
    'access.authorized',
    'access.denied',
    'door.forced_open',
    'door.held_open',
    'intercom.call_start',
    'enrollment.detected',
    'device.state_changed',
    'lockdown.changed',
    'audit.appended',
    'snapshot.available',
]);
export function isKnownEventType(type) {
    return KNOWN_EVENT_TYPES.has(type);
}
//# sourceMappingURL=event.js.map